import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BudgetProvider } from './contexts/BudgetContext';
import 'bootstrap/dist/css/bootstrap.min.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <BudgetProvider>
        <App />
    </BudgetProvider>
);